import * as types from "../actions/ActionTypes";

const defaultState = {
  mediaPosting: false,
  mediaPosted: false,
  playerProgress: null,
  prevPlayerProgress: null,
  playerDuration: null,
  playerHasEnd: false,
  showNextEpisode: false,
  dismissNextEpisode: false,
  omitNextEpisode: false,
  bufferEnd: false,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case types.MEDIA_POST_PENDING:
      return Object.assign({}, state, {
        mediaPosting: true,
      });
    case types.MEDIA_POST_FULFILLED:
      return Object.assign({}, state, {
        mediaPosting: false,
        mediaPosted: true,
      });
    case types.MEDIA_POST_REJECTED:
      return Object.assign({}, state, {
        mediaPosting: false,
        mediaPostError: action.payload.response,
      });
    case types.SET_PLAYER_DURATION:
      return {
        ...state,
        playerDuration: action.payload,
      };
    case types.SET_PLAYER_PROGRESS:
      return {
        ...state,
        playerProgress: action.payload,
      };
    case types.SET_PLAYER_END:
      return {
        ...state,
        playerProgress: null,
        playerDuration: null,
        playerHasEnd: true,
      };
    case types.SET_PLAYER_START:
      return {
        ...state,
        playerHasEnd: false,
      };

    case types.SHOW_NEXT_EPISODE:
      return {
        ...state,
        showNextEpisode: true,
      };
    case types.DISMISS_NEXT_EPISODE:
      return {
        ...state,
        showNextEpisode: false,
        dismissNextEpisode: true,
      };
    case types.RESET_NEXT_EPISODE_VALUE:
      return {
        ...state,
        showNextEpisode: false,
        dismissNextEpisode: false,
      };
    case types.SET_BUFFER_START: {
      return {
        ...state,
        bufferEnd: false,
      };
    }
    case types.SET_BUFFER_END: {
      return {
        ...state,
        bufferEnd: true,
      };
    }
    default:
      return state;
  }
}
